import {
	CLEAR,
	ERROR,
	SUCCESS,
	LOADING,
	GET_STATUS
} from "./switchActionsCreator";

const defaultState = {
	status:[],
	devices:{}
};

export default function switchReducer(state = defaultState, action) {
	switch (action.type) {
		case LOADING: {
			return {
				...state,
				loading: action.data
			};
		}
		case ERROR: {
			return {
				...state,
				loading: false,
				error: action.data
			};
		}
		case SUCCESS: {
			return {
				...state,
				loading: false,
				success: true
			};
		}
		case CLEAR: {
			return {
				...state,
				loading: false,
				success: false,
				error: null
			};
		}
		case GET_STATUS: {

			return {
				...state,
				status: action.data
			};
		}
		default: return state;
	}
}